import { render, staticRenderFns } from "./EditEmploiDialog.vue?vue&type=template&id=6224d0fa&"
import script from "./EditEmploiDialog.vue?vue&type=script&lang=js&"
export * from "./EditEmploiDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports